"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactSharedUiNext = require("@eon-funke/react-shared-ui-next");
var _MeterNumberValidationHelpers = _interopRequireDefault(require("../../../../../utils/MeterNumberValidationHelpers"));
var _DateIcon = _interopRequireDefault(require("./DateIcon"));
var _meterReadingFormHelper = require("../MeterReadingForm/meterReadingFormHelper");
var _meterReadingDateInputHelper = require("../../Core/MeterReadDateInput/meterReadingDateInputHelper");
var _EditIcon = _interopRequireDefault(require("./EditIcon"));
var _DeviceIcon = _interopRequireDefault(require("./DeviceIcon"));
var MeterInformationBox = function MeterInformationBox(props) {
  var serialNumber;
  var typeDisplay;
  var dateDisplay;
  if (props.deviceData) {
    serialNumber = props.deviceData.obfuscationActive ? props.deviceData.serialNumberObfuscated : props.deviceData.serialNumber;
    serialNumber = _MeterNumberValidationHelpers.default.removeRedundantZeros(serialNumber);
    dateDisplay = (0, _meterReadingDateInputHelper.prepareDateForDisplay)(props.deviceData.registers);
    typeDisplay = (0, _meterReadingFormHelper.prepareEnergyTypeForDisplay)(props.deviceData);
  }
  var classNameStart = 'text-center ano-meter-informationbox__value ano-meter-informationbox__value__';
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "ano-meter-informationbox row Rectangle"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "col-md-4 col-sm-6 col-xs-6"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "text-center ano-meter-informationbox__value ".concat(typeDisplay.energyTypeClass)
  }, /*#__PURE__*/_react.default.createElement(_reactSharedUiNext.Icon, {
    glyph: typeDisplay.iconType,
    size: "36",
    style: {
      fill: '#767676'
    }
  })), /*#__PURE__*/_react.default.createElement("h5", {
    className: "text-center ano-meter-informationbox__icon"
  }, typeDisplay.energyTypeValue), /*#__PURE__*/_react.default.createElement("h5", {
    className: "text-center ano-meter-informationbox__text"
  }, props.energyTypeLabel)), /*#__PURE__*/_react.default.createElement("div", {
    className: "col-md-4 col-sm-6 col-xs-6"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "".concat(classNameStart, "serial-number")
  }, /*#__PURE__*/_react.default.createElement(_DeviceIcon.default, null)), /*#__PURE__*/_react.default.createElement("h5", {
    className: "text-center ano-meter-informationbox__icon"
  }, serialNumber), /*#__PURE__*/_react.default.createElement("h5", {
    className: "text-center ano-meter-informationbox__text"
  }, props.deviceNumberLabel)), /*#__PURE__*/_react.default.createElement("div", {
    className: "col-md-4 col-sm-12 col-xs-12 ano-meter-informationbox__last-read-date"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "".concat(classNameStart, "last-reading-date")
  }, /*#__PURE__*/_react.default.createElement(_DateIcon.default, null)), /*#__PURE__*/_react.default.createElement("h5", {
    className: "text-center ano-meter-informationbox__icon"
  }, "".concat(props.editButton ? props.newMeterReadingDate : dateDisplay), props.editButton && '   ', props.editButton && /*#__PURE__*/_react.default.createElement(_EditIcon.default, {
    paginate: props.paginate
  })), /*#__PURE__*/_react.default.createElement("h5", {
    className: "text-center ano-meter-informationbox__text"
  }, props.lastReadingDateLabel)));
};
var _default = exports.default = MeterInformationBox;